"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zh = exports.ko = exports.ja = exports.fr = exports.es = exports.en = void 0;

var en = require("./en.json");

exports.en = en;

var es = require("./es.json");

exports.es = es;

var fr = require("./fr.json");

exports.fr = fr;

var ja = require("./ja.json");

exports.ja = ja;

var ko = require("./ko.json");

exports.ko = ko;

var zh = require("./zh.json");

exports.zh = zh;